import { createIcon } from '@chakra-ui/icons'

export const BulletListIcon = createIcon({
  displayName: 'BulletListIcon',
  viewBox: '0 0 12 12',
  path: (
    <>
      <path d="M2.5 3.5C2.77614 3.5 3 3.27614 3 3C3 2.72386 2.77614 2.5 2.5 2.5C2.22386 2.5 2 2.72386 2 3C2 3.27614 2.22386 3.5 2.5 3.5Z" />
      <path d="M4.5 2.5C4.22386 2.5 4 2.72386 4 3C4 3.27614 4.22386 3.5 4.5 3.5H10C10.2761 3.5 10.5 3.27614 10.5 3C10.5 2.72386 10.2761 2.5 10 2.5H4.5Z" />
      <path d="M4 6C4 5.72386 4.22386 5.5 4.5 5.5H10C10.2761 5.5 10.5 5.72386 10.5 6C10.5 6.27614 10.2761 6.5 10 6.5H4.5C4.22386 6.5 4 6.27614 4 6Z" />
      <path d="M2.5 6.5C2.77614 6.5 3 6.27614 3 6C3 5.72386 2.77614 5.5 2.5 5.5C2.22386 5.5 2 5.72386 2 6C2 6.27614 2.22386 6.5 2.5 6.5Z" />
      <path d="M4 9C4 8.72386 4.22386 8.5 4.5 8.5H10C10.2761 8.5 10.5 8.72386 10.5 9C10.5 9.27614 10.2761 9.5 10 9.5H4.5C4.22386 9.5 4 9.27614 4 9Z" />
      <path d="M2.5 9.5C2.77614 9.5 3 9.27614 3 9C3 8.72386 2.77614 8.5 2.5 8.5C2.22386 8.5 2 8.72386 2 9C2 9.27614 2.22386 9.5 2.5 9.5Z" />
    </>
  ),
})
